import React from 'react';

export const API_URL: string = process.env.REACT_APP_API_URL || 'https://api.getnovala.com';

export const PRIVACY_KEY = 'novala_privacy';

export const AVATAR_COLORS: ReadonlyArray<string> = [
  '#0F9599', '#0B7377', '#185FA5', '#7C3AED',
  '#DB2777', '#0891B2', '#65A30D', '#B45309',
];

export const PRIVATE_MASK: React.ReactNode = (
  <span style={{ display: 'inline-flex', alignItems: 'center', color: '#12262B' }}>
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="none">
      <path d="M18 8h-1V6a5 5 0 0 0-10 0v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zm-9-2a3 3 0 0 1 6 0v2H9V6zm4 10h-2v-3h2v3z"/>
    </svg>
  </span>
);